import * as React from 'react';
import { LegacyRef } from 'react';
import styled from 'styled-components';
import { IBInputFileProps } from './InputFile.types';

import '../Input/Input.scss';

const StyledInputFile = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  user-select: none;
`;

const InputFileButton = styled.label<{ disabled: boolean }>`
  cursor: pointer;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 24px;
  padding: 0 12px;
  color: ${({ theme }) => theme.colors.font1};
  height: 24px;
  background: #f2f2ed;
  border: 0.75px solid ${({ theme }) => theme.colors.font1};
  box-sizing: border-box;
  border-radius: 4px;
  user-select: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  ${({ disabled, theme }) =>
    disabled
      ? `
      color: ${theme.colors.elevation1};
      border-color: ${theme.colors.elevation1};
      cursor: unset;
    `
      : `
      &:hover {
        background-color: ${theme.colors.background}
      }
    `};
`;

const InputFile: React.FC<IBInputFileProps> = (props: IBInputFileProps) => {
  const {
    className,
    onChange,
    children,
    type,
    accept = '',
    disabled = false,
    testId
  } = props;
  const fileInputRef: LegacyRef<HTMLInputElement> = React.createRef();

  return (
    <>
      <StyledInputFile
        data-testid={testId || 'input-file'}
        className={`${className} input`}
        name="bInputFile"
        id="bInputFile"
        ref={fileInputRef}
        type="file"
        multiple={type === 'multi'}
        accept={accept}
        disabled={disabled}
        onChange={e => {
          if (onChange && e.target && e.target.files) {
            if (type === 'single') {
              onChange(e.target.files[0]);
            } else if (type === 'multi') {
              onChange(Array.from(e.target.files));
            }
          }
          fileInputRef.current.value = '';
        }}
      />
      <InputFileButton disabled={disabled} htmlFor="bInputFile">
        {children}
      </InputFileButton>
    </>
  );
};

export default InputFile;
